import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserAuthService } from '../../services/user-auth.service';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-gwas15',
  templateUrl: './gwas15.component.html',
  styleUrl: './gwas15.component.scss',
})
export class Gwas15Component implements OnInit {
  plotEndpoint: string = environment.baseUrl + 'manhattan/plot';
  plotSrc: SafeResourceUrl | undefined;
  isLoading = true;
  error: HttpErrorResponse | undefined;

  constructor(
    public auth: UserAuthService,
    public sanitize: DomSanitizer,
    private router: Router,
    private api: ApiService
  ) {}

  ngOnInit() {
    this.loadGRCh37Dataset();
  }

  loadGRCh37Dataset() {
    this.api.getGRCh37Datasets().subscribe({
      next: (datasets) => {
        if (datasets.length > 0) {
          // Take the first (and presumably only) dataset
          const datasetName = datasets[0].name;
          this.loadPlot(datasetName);
        } else {
          // No datasets available, redirect to homepage
          this.router.navigate(['/home']);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.error = err;
        this.isLoading = false;
        // Redirect to homepage after showing error briefly
        setTimeout(() => {
          this.router.navigate(['/home']);
        }, 3000);
      },
    });
  }

  loadPlot(datasetName: string) {
    this.plotSrc = this.sanitize.bypassSecurityTrustResourceUrl(
      this.plotEndpoint + '?token=' + this.auth.getToken() + '&dataset=' + datasetName
    );
    this.isLoading = false;
  }

  goBack() {
    this.router.navigate(['/home']);
  }
}
